require('./e3-hotspot-tooltip.scss');

import E3Tooltip from '../e3-tooltip/e3-tooltip';
import PreviewCreator from './preview-creator';
import {isNode} from 'service/html.service';

const imageWrapperClassName = 'e3-hotspot-tooltip__image';

class E3HotspotTooltip extends E3Tooltip {
    _current = null;
    _candidate = null;
    _loadingTimer = null;
    _hidePromise = Promise.resolve();
    _hideReject = null;
    _hideResolve = null;
    _previewCreator = null;


    constructor(options) {
        super(options);

        this._previewCreator = new PreviewCreator();
    }

    add(id, element, src, config) {
        this._elements[id] = {element, src, config};

        this._bindEvents(id);
    }

    remove(id) {
        if (!this._elements[id]) return;

        this._unbindEvents(id);

        delete this._elements[id];
    }

    hideTooltip() {
        let id = this._current;

        if (!id || !this._elements[id]) return;

        let element = this._elements[id].element;
        this._unbindEvents(id);
        this._hideTooltip(element, false);
    }

    _init() {
        let {className, titleTag} = this._options;
        let title = document.createElement(titleTag);
        let wrapper = document.createElement('div');

        wrapper.classList.add(imageWrapperClassName);
        wrapper.appendChild(title);

        this._tooltip.element = document.createElement('div');

        this._tooltip.element.classList.add(className);
        this._tooltip.element.appendChild(wrapper);

        this._tooltip.title = wrapper;
    }

    _onMouseEnter(id) {
        if (window.e3touchDevice) return;

        if (this._current === id) {
            this._candidate = null;
            if (this._hideReject) this._hideReject();
            this._hidePromise = Promise.resolve();
            this._tooltip.element.removeEventListener('animationend', this._hideResolve, {capture: false, once: true});
            this._toggleTooltip();
            return;
        }

        if (!this._candidate) {
            this._hidePromise.then(() => this._showTooltip(this._candidate))
        }

        this._candidate = id;
    }

    _onMouseLeave(id) {
        let element = this._elements[id].element;

        if (window.e3touchDevice || this._current !== id || !element) return;

        this._hidePromise = this._hideTooltip(element);
    }

    _showTooltip(id) {
        if (!id) return;

        let element = this._elements[id].element;
        let {src, config} = this._elements[id];
        let {loadingClassName, className} = this._options;
        this._current = id;
        this._candidate = null;
        this._hideReject = null;
        this._hidePromise = Promise.resolve();

        if (!element) return;

        // this._tooltip.title.onload = this._onImageLoaded.bind(this);
        // this._tooltip.title.src = src;

        // this._loadingTimer = setTimeout(() => {
        //     this._tooltip.element.classList.add(loadingClassName);
        //     this._loadingTimer = null;
        // }, delay);


        this._previewCreator.getPreview(src, config)
            .then((canvas) => this._onPreviewReady(canvas));

        element.appendChild(this._tooltip.element);
        this._tooltip.element.classList.add(`${className}--fade-in`);
        this._tooltip.element.classList.add(loadingClassName);
    }

    _onPreviewReady(canvas) {
        let {loadingClassName} = this._options;

        this._tooltip.title.innerHTML = '';
        this._tooltip.title.appendChild(canvas);
        this._tooltip.element.classList.remove(loadingClassName);
    }

    _toggleTooltip() {
        let {className, loadingClassName} = this._options;
        this._tooltip.element.classList.add(`${className}--fade-in`);
        this._tooltip.element.classList.remove(loadingClassName);
    }

    _hideTooltip(element, cancaleble = true) {
        let {className} = this._options;

        return new Promise((resolve, reject) => {
            this._tooltip.element.addEventListener('animationend', resolve, {capture: false, once: true});
            if (cancaleble) {
                this._hideResolve = resolve;
                this._hideReject = reject;
            }
            this._tooltip.element.classList.remove(`${className}--fade-in`);
        }).then(() => {
            try {
                let canvas = this._tooltip.element.querySelector('canvas');
                if(!isNode(canvas)) return ;
                this._tooltip.title.removeChild(canvas);
                element.removeChild(this._tooltip.element);
                this._current = null;
                this._hideReject = null;
            } catch (e) {
                // means that element or tooltip
                // has been already removed from DOM
                console.log('remove child failed');
                return;
            }

            this._tooltip.title.src = '';
        })
        .catch((e) => {
            console.log('Was rejected');
        });
    }
}

export default E3HotspotTooltip;
